import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const config = {
	withCredentials: true,
	headers: { 'Content-Type': 'application/json' },
};
export class NotificationsApi {
	//login logs
	static getPortalAccessDetails(params) {
		const url = `${BASE_URL}/notifications/portalAccess`;
		return axios.post(url, params, config);
	}
	//badge logs
	static getOrgDataCenterAccess(orgId, userId) {
		const url = `${BASE_URL}/notifications/${orgId}/${userId}/badgeAccess`;
		return axios.get(url, config);
	}
	//useraccess logs - downloading stuff
	static getUserAccessLogs(userId) {
		const url = `${BASE_URL}/notifications/${userId}/useraccess`;
		return axios.get(url, config);
	}
}
